import {useGameStore} from "@/stores/gameStore";
import {usePlayerRelationStore} from "@/stores/playerRelations";
import type Turn from "@/types/PublicRouter/Turn";
import { logger } from '@/models/logger';

export default class PublicRouter {

    private gameStore = useGameStore()
    private playerRelationStore = usePlayerRelationStore()

    public route(event: string, data: unknown): void {
        logger.debug('Routing public event: ' + event)
        switch (event) {
            case 'turn':
                // Sync Initial Map Data
                this.turn(data as Turn)
                break
            case 'player_online_status_update':
                this.playerOnlineStatusUpdate(data as { onlinePlayers: Record<string, number>; serverTimestamp: number })
                break
            case 'ship_command_block_enabled':
                this.setShipCommandBlock(true)
                break;
            case 'ship_command_block_disabled':
                this.setShipCommandBlock(false)
                break;
            default:
                logger.warn('Unknown event: ' + event)
                break
        }
    }

    private turn(data: Turn): void {
        this.gameStore.turn = data.turn
        this.gameStore.dayTurnedAt = (Date.now() / 1000) - data.dayOffset;
        this.gameStore.weekTurnedAt = (Date.now() / 1000) - data.weekOffset
    }

    private playerOnlineStatusUpdate(data: { onlinePlayers: Record<string, number>; serverTimestamp: number }): void {
        this.playerRelationStore.updateOnlineStatus(data.onlinePlayers, data.serverTimestamp)
    }

    private setShipCommandBlock(enabled: boolean): void {
        this.gameStore.shipCommandBlock = enabled
    }
}
